<template>
  <div>
    <el-dialog
      ref="viewDialog"
      v-dialogDrag
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      class="h600_dialog abow_dialog"
      width="1100px"
      :before-close="modalClose"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      append-to-body
      @open="handleOpen('viewDialog')"
    >
      <div
        v-loading="loading"
        :loading="loading"
        :element-loading-text="loadingText"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <el-form
          ref="dialogViewForm"
          :model="dialogViewForm"
          class="add-edit-view-form"
          @submit.native.prevent
        >
          <div class="modal-box">
            <h3 class="modal-title">
              基础信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="拜访客户">
                    <el-input
                      v-model="dialogViewForm.storeName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="客户地址">
                    <el-input
                      v-model="dialogViewForm.address"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拜访日期">
                    <el-input
                      v-model="dialogViewForm.visitDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拜访时间">
                    <el-input
                      v-model="dialogViewForm.visitPeriodStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拜访停留时间">
                    <el-input
                      v-model="dialogViewForm.visitTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="拜访方式">
                    <el-input
                      v-model="dialogViewForm.visitMethodStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="工作内容">
                    <el-input
                      v-model="dialogViewForm.visitTypeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="签到时间">
                    <el-input
                      v-model="dialogViewForm.dingCheckDateStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="签到人">
                    <el-input
                      v-model="dialogViewForm.visitUserName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="签到地点">
                    <el-input
                      v-model="dialogViewForm.dingAddress"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    prop="visitPurpose"
                    label="拜访目的"
                  >
                    <el-input
                      v-model="dialogViewForm.visitPurpose"
                      type="textarea"
                      placeholder="请输入拜访目的"
                      style="margin-top:-10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    prop="visitInfo"
                    label="拜访总结"
                  >
                    <el-input
                      v-model="dialogViewForm.visitInfo"
                      type="textarea"
                      placeholder="请输入拜访总结"
                      style="margin-top:-10px;"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              陈列信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="6">
                  <el-form-item label="云产卷烟陈列现状">
                    <el-input
                      v-model="dialogViewForm.yunDisplayStatusStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.yunDisplayStatus === 1"
                  :span="6"
                >
                  <el-form-item label="集中陈列条数">
                    <el-input
                      v-model="dialogViewForm.displayCount"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.yunDisplayStatus === 1"
                  :span="6"
                >
                  <el-form-item label="集中陈列格数">
                    <el-input
                      v-model="dialogViewForm.displayGridStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.yunDisplayStatus === 1"
                  :span="24"
                >
                  <el-form-item label="陈列品规">
                    <el-input
                      v-model="dialogViewForm.displaySortStr"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.yunDisplayStatus === 0"
                  :span="6"
                >
                  <el-form-item label="无陈列原因">
                    <el-input
                      v-model="dialogViewForm.noDisplayReasonStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col
                  v-if="dialogViewForm.yunDisplayStatus === 0"
                  :span="24"
                >
                  <el-form-item
                    label="无陈列说明"
                    prop="noDisplayExplanation"
                  >
                    <el-input
                      v-model="dialogViewForm.noDisplayExplanation"
                      type="textarea"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
          <div
            v-if="showDataCollect"
            class="modal-box"
          >
            <h3 class="modal-title">
              动销调查
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="6">
                  <el-form-item label="采集日期">
                    <el-input
                      v-model="dialogViewForm.surveyDate"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-table
                    :data="surveyListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="productName"
                      label="品规名称"
                      width="140"
                    />
                    <el-table-column
                      prop="orderDate"
                      label="到货日期"
                      width="120"
                    />
                    <el-table-column
                      prop="orderAmount"
                      label="到货条数"
                    />
                    <el-table-column
                      prop="inventoryAmount"
                      label="当前库存(包)"
                    />
                    <el-table-column
                      prop="packagePrice"
                      label="包零售价"
                    />
                    <el-table-column
                      prop="orderPrice"
                      label="条零售价"
                    />
                    <el-table-column
                      prop="marketPrice"
                      label="集市交易价"
                    />
                    <el-table-column
                      prop="dynamicSalesStr"
                      label="动销情况"
                    />
                    <el-table-column
                      prop="opinionStr"
                      label="意见"
                    />
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              使用物料
            </h3>
            <div class="modal-row-box">
              <el-row
                :gutter="10"
                style="margin-bottom:10px;"
              >
                <el-col :span="24">
                  <el-table
                    :data="materialListData"
                    style="width: 100%"
                    :header-cell-style="{background:'#0076ff'}"
                    border
                  >
                    <el-table-column
                      type="index"
                      label="序号"
                      width="60"
                    />
                    <el-table-column
                      prop="schemeNo"
                      label="方案编号"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.schemeNo }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="materialsName"
                      label="物料名称"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.materialsName }}
                      </template>
                    </el-table-column>
                    <el-table-column
                      prop="unitName"
                      label="单位"
                      width="80"
                    >
                      <template slot-scope="scope">
                        {{ scope.row.unitName }}
                      </template>
                    </el-table-column>
                    <el-table-column label="数量">
                      <template slot-scope="scope">
                        {{ scope.row.amount }}
                      </template>
                    </el-table-column>
                    <el-table-column label="用途">
                      <template slot-scope="scope">
                        {{ scope.row.usedMethod }}
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
            </div>
          </div>
          <div class="modal-box">
            <div class="modal-row-box">
              <div class="demo-input-suffix">
                <div class="demo-input-suffix">
                  <span class="title-sp">照片信息</span>
                </div>
                <show-preview :arr-file-data="picList" />
              </div>
            </div>
          </div>
          <div class="modal-box">
            <h3 class="modal-title">
              操作备注信息
            </h3>
            <div class="modal-row-box">
              <el-row :gutter="10">
                <el-col :span="12">
                  <el-form-item label="操作人">
                    <el-input
                      v-model="dialogViewForm.operatorName"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="操作时间">
                    <el-input
                      v-model="dialogViewForm.operationTimeStr"
                      disabled
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注">
                    <el-input
                      v-model="dialogViewForm.remark"
                      type="textarea"
                      placeholder="备注"
                      disabled
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </el-form>
      </div>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="modalClose">
          关闭
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// dialog 拖拽dialogDragMixin
import dialogDragMixin from '@/mixin/dialogDragMixin'
// 图片预览
import showPreview from '@/components/showPreview'
// 数据请求
import { initStoreVisitReportApi } from '@/api/storeVisitReport'
export default {
  components: { showPreview },
  mixins: [dialogDragMixin],
  props: {
    dialogTitle: {
      type: String,
      default: ''
    },
    eventType: {
      type: String,
      default: ''
    },
    dialogVisible: {
      type: Boolean,
      default: false
    },
    dataId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      operateButtonDisable: false,
      loading: false,
      loadingText: '努力加载数据中，请耐心等待',
      dialogViewForm: {
      },
      materialListData: [],
      surveyListData: [],
      showDataCollect: false,
      picList: [],
      baseUrl: ''
    }
  },
  watch: {
    dialogVisible(val) {
      if (val) {
        this.loading = true
        this.materialListData = []
        this.surveyListData = []
        this.showDataCollect = false,
          this.picList = []
        this.baseUrl = process.env.VUE_APP_BASE_API
        this.dialogViewForm = {
          storeName: '',
          address: '',
          visitDateStr: '',
          visitPeriodStr: '',
          visitTimeStr: '',
          visitMethodStr: '',
          visitTypeStr: '',
          visitPurpose: '',
          dingCheckDateStr: '',
          visitUserName: '',
          dingAddress: '',
          visitInfo: '',
          yunDisplayStatus: null,
          yunDisplayStatusStr: '',
          displayCount: 0,
          displayGridStr: '',
          displaySortStr: '',
          noDisplayReasonStr: '',
          noDisplayExplanation: '',
          operatorName: '',
          operationTimeStr: '',
          remark: '',
          surveyDate: ''
        }
        this.initData()
      }
    }
  },
  methods: {
    // 加载数据
    initData() {
      initStoreVisitReportApi({ id: this.dataId }).then(res => {
        const { bill, detailList, surveyList } = res.data
        for (let key in this.dialogViewForm) {
          if (key !== 'surveyDate') {
            this.dialogViewForm[key] = bill[key]
          }
        }
        this.materialListData = detailList
        for (let i = 1; i <= 10; i++) {
          if (bill['pic' + i] && bill['pic' + i] !== '') {
            let obj = {}
            obj.name = bill['pic' + i]
            obj.url = this.baseUrl + bill['pic' + i]
            obj.attachmentName = bill['pic' + i]
            obj.attachmentUrl = bill['pic' + i]
            this.picList.push(obj)
          }
        }
        let surveyDate = ''
        surveyList.forEach(item => {
          item.orderDate = item.orderDateStr
          if (surveyDate === '') surveyDate = item.surveyDateStr
        })
        this.dialogViewForm.surveyDate = surveyDate
        this.surveyListData = surveyList
        bill.visitType.split(',').forEach(typeId => {
          if (Number(typeId) === 3) {
            this.showDataCollect = true
          }
        })
        this.loading = false
      })
    },
    modalClose() {
      this.$emit('update:dialogVisible', false) // 直接修改父组件的属性
      this.$refs.dialogViewForm.clearValidate()
    }
  }
}
</script>
<style lang="scss"  scoped>
.el-table--border {
  border-left: 1px solid #dfe6ec;
  margin-top: 5px;
}
::v-deep .el-table {
  th {
    color: #ffffff;
    .cell {
      line-height: 17px;
    }
    .caret-wrapper {
      height: 18px;
    }
    .sort-caret {
      border-width: 4px;
      &.ascending {
        top: 0;
      }
      &.descending {
        bottom: 0;
      }
    }
  }
  .ascending .sort-caret.ascending {
    border-bottom-color: #ffffff;
  }
  .descending .sort-caret.descending {
    border-top-color: #ffffff !important;
  }
}
::v-deep .el-table--mini th,
::v-deep .el-table--mini td {
  padding: 4px;
  font-size: 12px;
}
::v-deep .el-table--mini td {
  padding: 4px;
}
.demo-input-suffix {
  padding: 10px 0;
  .el-input {
    margin-right: 10px;
    width: 120px;
  }
  .title-sp {
    color: #1a9bff;
    margin-right: 10px;
  }
}
</style>
